// 数据别名处理
// 传入处理好的params，以及需要复制的字段、新字段名

exports.install = (Vue) => {
  /**
   * 复制条件生成别名字段，并且删除原始条件
   * @param {Object} params 外层对象，包含result数组
   * @param {string} sourceField 原fieldName
   * @param {string} targetField 复制后的新fieldName
   */
  Vue.prototype.CloneQueryItem = function (params, sourceField, targetField) {
    const list = params.result;
    if (!Array.isArray(list)) return params;

    const originIndex = list.findIndex((x) => x.fieldName === sourceField);
    if (originIndex === -1) return params;

    // 获取原始对象
    const origin = list[originIndex];
    // 复制生成新对象
    const newItem = { ...origin, fieldName: targetField };

    // 删除原有条目
    list.splice(originIndex, 1);
    // 推入新条目
    list.push(newItem);

    return params;
  };
};
